import { RiskWorkspace } from '@app/types/workspaceTypes'

/**
 * Returns whether a workspace can be selected based on minimum layer data.
 */
export const isWorkspaceSelectable = (workspace: RiskWorkspace): boolean => {
  const assets = workspace.layers?.assets ?? []
  const scenarios = workspace.layers?.scenarios ?? []
  const capitalSets = workspace.capital_sets ?? []

  return assets.length > 0 && scenarios.length > 0 && capitalSets.length > 0
}

/**
 * Builds a short summary string with hazard and element counts for a workspace.
 */
export const getWorkspaceMeta = (workspace: RiskWorkspace): string => {
  const hazardCount = workspace.layers?.scenarios?.length ?? 0
  const elementCount = workspace.layers?.assets?.length ?? 0

  return `${hazardCount} hazards · ${elementCount} elements`
}
